import { render, staticRenderFns } from "./SubscribeWithEmailCTA.vue?vue&type=template&id=64ab2367&scoped=true&"
import script from "./SubscribeWithEmailCTA.vue?vue&type=script&lang=js&"
export * from "./SubscribeWithEmailCTA.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeWithEmailCTA.vue?vue&type=style&index=0&id=64ab2367&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab2367",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MailIcon: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NewsletterBanner/MailIcon.vue').default})
